
import { Dossier } from "@/models/dossier";
import { DossierPeppolID } from "@/models/dossier-peppol-id";
import { CompanyDossierService } from "@/services";
import Vue from "vue";
import { IDataTableColumn } from "winfakt-vue-components";
import AppDossierPeppolEndpointCreateModal from "./DossierPeppolEndpointCreateModal.vue";

export default Vue.extend({
	data(){
		return {
			registrations: [] as DossierPeppolID[],
			selectedRows: [] as DossierPeppolID[],
			registerModalOpen: false,
			registering: false
		};
	},
	props: {
		dossier: {
			type: Object as ()=>Dossier,
			required: true
		}
	},
	computed: {
		columns():IDataTableColumn[]{
			return [
				{
					name: "Peppol ID",
					property: "peppolId",
					width: "200px"
				},
				{
					name: "Opties",
					property: "sendOnly",
					width: "200px",
					print(val:boolean):string{
						if (val){
							return "Enkel verzenden";
						}
						return "Verzenden en ontvangen";
					}
				},
				{
					name: "Heeft self billing",
					property: "hasSelfBilling",
					width: "200px",
					print(val:boolean):string{
						if (val) return "Ja";
						return "Nee";
					}
				}
			];
		}
	},
	methods: {
		add(){
			this.registerModalOpen = true;
		},
		async remove(){
			let result = await this.$wf.confirm(`Weet je zeker dat je ${this.selectedRows.length} registratie(s) wilt verwijderen?`, "Ja", "Nee");
			if (!result) return;
			for (let item of this.selectedRows){
				await CompanyDossierService.deletePeppolEndpoint(this.dossier.id, item.peppolId);
			}
			this.selectedRows.splice(0, this.selectedRows.length);
			this.fetch();
		},
		async fetch(){
			this.registrations = await CompanyDossierService.getPeppolRegistrations(this.dossier.id);
		},
		compare(s1:DossierPeppolID, s2:DossierPeppolID):boolean{
			return s1.peppolId == s2.peppolId;
		},
		async registerForSelfBilling(){
			if (this.registering) return;
			try{
				this.registering = true;
				await CompanyDossierService.registerPeppolSelfBilling(this.dossier.id);
				this.$wf.notify("Self billing staat aan", "success", 3000, "check");
				await this.fetch();
			}finally{
				this.registering = false;
			}
		},
		async unregisterForSelfBilling(){
			if (this.registering) return;
			try{
				this.registering = true;
				await CompanyDossierService.unregisterPeppolSelfBilling(this.dossier.id);
				this.$wf.notify("Self billing staat uit", "success", 3000, "check");
				await this.fetch();
			}finally{
				this.registering = false;
			}
		}
	},
	mounted(){
		this.fetch();
	},
	components: {
		AppDossierPeppolEndpointCreateModal
	}
});
